import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";
import styles from 'assets/jss/Report/ReportStyle';
import {usePatientInfo} from "hooks/usePatient";
const useStyles = makeStyles(styles);

const PieChartLabels = ({patientId}) => {
    const {data: patientInfo} = usePatientInfo(patientId);
    const {isPregnant} = patientInfo || {}

    const classes = useStyles();
    const range = isPregnant?['120','60 - 120','60']:['180','70 - 180','70']
    const labels = [
        {
            label :`high ( > ${range[0]} )`,
            color:'#feb140'
        },
        {
            label :`In Range ( ${range[1]} )`,
            color:'#3bba4c'
        },
        {
            label :`Low ( < ${range[2]} )`,
            color:'#d81d5d'
        }
    ]
    return (
        <Grid
            container
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                m: '0 auto',
                mb: '57px',
                borderRadius: '22px',
                height: '40px',
                display: 'flex',
                lg: 8
            }}

        >
            {labels.map((item)=>(
                <Grid className={classes.ChildChart} item flexDirection={'row-reverse'}>
                    <div className={classes.labelContainer} style={{ background:item.color }} />
                    <p className={classes.TextChart} style={{ color: item.color }}>{item.label}</p>
                </Grid>
            ))}

        </Grid >
    );
};

export default PieChartLabels;
